import i18n from '../i18n';
import type { AppLocale } from '../i18n';

/** Localized "current of total" label under image carousels (lesson, book, tag, admin preview). */
export function formatImageCarouselCounter(
  current: number,
  total: number,
  locale?: AppLocale
): string {
  return i18n.t('imageCarousel.imageOf', {
    ns: 'learning',
    current,
    total,
    defaultValue: '{{current}} of {{total}}',
    ...(locale ? { lng: locale } : {}),
  });
}
